import React from 'react'
import { Grid } from "@mui/material"
import { AppFormSection } from "@components"

import AlertsBaseDrawer from "Pages/ReportsAlerts/Alerts/Conditions/@components/Drawer"
import {
	AlertsComparator,
	AlertsComparatorUnit,
	AlertsComparatorValue,
	AlertsComparisonType,
	AlertsConditionName,
	AlertsDrawerBaseFooter,
	AlertsMainProviders,
	AlertsMoreFeatures,
	AlertsSameInsurance
} from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsMainSites from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Drawer/MainSites"
import AlertsSites from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Drawer/Sites"
import AlertsProviders from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison/Drawer/Providers"


export default function PriceComparisonDrawer({ onSubmitAlert, isLoading }) {

	return <AlertsBaseDrawer
		footer={<AlertsDrawerBaseFooter isLoading={isLoading} onSubmitAlert={onSubmitAlert}/>}
		content={<>
			<AppFormSection icon="tag" title="Condition">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pc-name">
					<AlertsConditionName/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="location-dot" title="Main site">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pc-main-site">
					<AlertsMainSites/>
				</Grid>
				<Grid item xs={12} data-tour-id="cond-pc-main-providers">
					<AlertsMainProviders/>
				</Grid>
				<Grid item xs={4} data-tour-id="cond-pc-comparator">
					<AlertsComparator/>
				</Grid>
				<Grid item xs={4} data-tour-id="cond-pc-comp-value">
					<AlertsComparatorValue/>
				</Grid>
				<Grid item xs={4} data-tour-id="cond-pc-comp-unit">
					<AlertsComparatorUnit/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="globe" title="Sites">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pc-sites">
					<AlertsSites/>
				</Grid>
				<Grid item xs={12} data-tour-id="cond-pc-providers">
					<AlertsProviders/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="scale-balanced" title="Comparison">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pc-comp-type">
					<AlertsComparisonType url={'comparison-type-price-comparison'}/>
				</Grid>
				<Grid item xs={12} data-tour-id="cond-pc-same-ins">
					<AlertsSameInsurance/>
				</Grid>
				</Grid>
			</AppFormSection>
			<AppFormSection icon="sliders" title="More features" hint="optional">
				<Grid container spacing={2}>
				<Grid item xs={12} data-tour-id="cond-pc-more">
					<AlertsMoreFeatures/>
				</Grid>
				</Grid>
			</AppFormSection>
		</>}
	/>
}